import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { OptionsType } from "types/UtilsTypes";

export default function useGetInvestmentCurrencies() {
  return useQuery({
    queryKey: ["investments/currencies"],
    queryFn: async () => {
      return axiosInstance
        .get("investments/currencies")
        .then((res) => res.data);
    },
    select: (data: OptionsType[]) => data,
    staleTime: 1000 * 60 * 60 * 24,
  });
}
